import React, { useCallback } from "react";
import { TextField } from "@mui/material";
import { NumericFormat } from "react-number-format";
import ErrorMessage from "components/form/ErrorMessage";

const NumberFormatCustom = React.forwardRef((props, ref) => {
  const { onChange, onBlur, min, max, ...other } = props;
  const handleChange = useCallback(
    (values) => {
      const { formattedValue, value } = values;

      onChange?.({
        target: {
          name: props.name,
          value: value,
        },
      });
    },
    [onChange, props.name]
  );

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      allowNegative={false}
      onValueChange={handleChange}
    />
  );
});

function NumberField({
  name,
  label,
  placeholder,
  thousandSeparator,
  decimalScale,
  isNumericString,
  allowLeadingZeros,
  allowNegative,
  min = 0,
  max = Infinity,
  disabled,
  onChange,
  onBlur,
  props,
  value,
  textFieldSx,
  error,
}) {
  const minValue = min ?? 0;
  const maxValue = max ?? Infinity;
  return (
    <TextField
      disabled={disabled}
      label={label}
      value={value ?? ""}
      fullWidth
      InputLabelProps={{
        shrink: true,
      }}
      size="small"
      FormHelperTextProps={{ variant: "standard" }}
      sx={textFieldSx}
      helperText={
        error?.text?.message?.message ? (
          <ErrorMessage message={error?.text?.message?.message} />
        ) : undefined
      }
      {...props}
      InputProps={{
        inputComponent: NumberFormatCustom,
        placeholder,
        inputProps: {
          thousandSeparator,
          decimalScale,
          isNumericString,
          allowLeadingZeros,
          allowNegative,
          name,
          onChange,
          onBlur,
          min: minValue,
          max: maxValue,
        },
      }}
    />
  );
}
export default NumberField;
NumberField.propTypes = {};
NumberField.defaultProps = {};
